import { useEffect, useState } from "react";
import { queryReconciliation } from "../api/newReportingClient";
import { ReconciliationResponse } from "../api/types";
import { ReportFilterValue } from "../components/NewReportFilters";

export interface ReconciliationState {
  data: ReconciliationResponse | null;
  loading: boolean;
  error: string | null;
}

// Fetches GET /reports/reconciliation for the selected event. Idle (no fetch, no data) until an
// event is picked — reconciliation is event-scoped. Cancels stale results on rapid filter changes.
export function useReconciliation(filters: ReportFilterValue): ReconciliationState {
  const [state, setState] = useState<ReconciliationState>({
    data: null,
    loading: false,
    error: null,
  });

  const eventId = filters.eventId;
  const key = JSON.stringify({ eventId, from: filters.from, to: filters.to });

  useEffect(() => {
    if (!eventId) {
      setState({ data: null, loading: false, error: null });
      return;
    }
    let cancelled = false;
    setState((s) => ({ ...s, loading: true, error: null }));

    queryReconciliation({
      eventId,
      from: filters.from || undefined,
      to: filters.to || undefined,
    })
      .then((data) => {
        if (!cancelled) setState({ data, loading: false, error: null });
      })
      .catch((err: unknown) => {
        if (!cancelled)
          setState({
            data: null,
            loading: false,
            error: err instanceof Error ? err.message : "Failed to load reconciliation",
          });
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return state;
}
